import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSite } from "@/lib/site";

const BRAND = "SaaSPivora";
const DEFAULT_DESC = "Discover, compare, and evaluate business software with practical reviews, detailed comparisons, and expert-informed buying guides.";

function setTag(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function Seo({ title, description, image, type = "website", jsonLd, noindex }) {
  const { settings } = useSite();
  const { pathname } = useLocation();
  const base = settings.site_url || "https://saaspivora.com";
  const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} — Discover Smarter. Choose Better.`;
  const desc = description || DEFAULT_DESC;
  const url = base + pathname;
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = fullTitle;
    setTag('meta[name="description"]', { name: "description", content: desc });
    setTag('link[rel="canonical"]', { rel: "canonical", href: url });
    setTag('meta[name="robots"]', { name: "robots", content: noindex ? "noindex,nofollow" : "index,follow" });
    setTag('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    setTag('meta[property="og:description"]', { property: "og:description", content: desc });
    setTag('meta[property="og:url"]', { property: "og:url", content: url });
    setTag('meta[property="og:type"]', { property: "og:type", content: type });
    setTag('meta[property="og:site_name"]', { property: "og:site_name", content: BRAND });
    setTag('meta[name="twitter:card"]', { name: "twitter:card", content: image ? "summary_large_image" : "summary" });
    if (image) setTag('meta[property="og:image"]', { property: "og:image", content: image });
    let script = document.getElementById("sp-jsonld");
    if (ld) {
      if (!script) { script = document.createElement("script"); script.type = "application/ld+json"; script.id = "sp-jsonld"; document.head.appendChild(script); }
      script.textContent = ld;
    } else if (script) script.remove();
  }, [fullTitle, desc, url, type, image, ld, noindex]);
  return null;
}
